import { cache } from "../../persistence/cache";
import { memoryCache } from "../../persistence/memoryCache";

const TITLES = "titles";

/**
 * Returns title id from the cache
 * @param {string} id Title id
 * @return {object} Title object
 */
async function getTitleCached(id) {
  if (this.localCache && this.localCache.memoryCache) {
    return memoryCache.get(id);
  }
  return await cache.get(id, { database: TITLES });
}

/**
 * Adds new time makers to a specific cached title
 * @param {string} titleId Title id
 * @param {string} mediaGuid Guid of the media title
 * @param {object} credits New time makers object
 */
export default async function addTimeMarkersToCachedTitle(titleId, mediaGuid, credits) {
  const title = await getTitleCached.call(this, titleId);
  const media = title.mediaContent.find(media => media.mediaGuid === mediaGuid);
  Object.assign(media, { credits });
  title.mediaContent = title.mediaContent.filter(item => item.mediaGuid !== mediaGuid);
  title.mediaContent.push(media);
  cache.remove(titleId, { database: TITLES });
  cache.set(titleId, title, {
    database: TITLES,
    expirationDate: title.mediaContent[0].expirationDate
  });
  if (this.localCache && this.localCache.memoryCache) {
    memoryCache.remove(titleId);
    memoryCache.set(titleId, title, {
      expiresIn: this.titlesCacheTime
    });
  }
}
